import {User} from '../../../entities/base/user';

export interface Draft {
    patientId: number;
    practiceId: number;
    profileId: number;
    draftType: DraftType;
    draftId: number;
    draftTitle: string;
    draftStatus: DraftStatus;
    createdDate: Date;
    modifiedDate: Date;
    createdUser: User;
    lastModifiedUser: User;
}

export enum DraftStatus {
    OPEN,
    MINIMIZED,
    MAXIMIZED,
    CLOSED
}

export type DraftType =
  'email' |
  'message' |
  'comment' |
  'report' |
  'script';
